export const faqs = [
  [
    'Is this only for advanced students?',
    'No. The system begins with Beginner Foundations and progressively develops through Beginner+, Intermediate, Intermediate+ and Advanced programming.',
  ],
  [
    'How many classes are included?',
    'You receive 156 complete classes organized across 52 weeks — three sessions per week: Class A, Class B and Class C.',
  ],
  [
    'Do I have to create the routines myself?',
    'No. The programming is already organized week by week. Open the corresponding volume, find the week and follow the class plan.',
  ],
  [
    'Is this designed for coaches?',
    'Yes. It is designed for stretching coaches, personal trainers, fitness instructors, mobility coaches and professionals who teach flexibility.',
  ],
  [
    'Can I use it with individual clients and groups?',
    'Yes. The classes and progressions can be adapted for individual coaching, and the system includes tools for managing different levels within the same class.',
  ],
  [
    'Does it include Pike, Split, Pancake and Bridge training?',
    'Yes. Each skill progresses from foundational positioning and mobility work to active flexibility and advanced, controlled variations — Pike, Front Split, Middle Split, Pancake and Bridge.',
  ],
  [
    'Is it only passive stretching?',
    'No. The system combines Mobility, Active Mobility, Static Flexibility, Active Flexibility, Isometric Control, Skill Preparation and Integration.',
  ],
  [
    'What if a student cannot perform an exercise?',
    'Bonus 02 — Stretching Problem Solver provides a practical system for reducing range, adding support, modifying the position or selecting a more appropriate variation.',
  ],
  [
    'How do I receive the material? Is it a subscription?',
    'After completing your purchase, you receive digital access to the PDF material. It is not a subscription — it is a one-time purchase.',
  ],
  [
    'How does the 7-day guarantee work?',
    "You have 7 days from your purchase to review the material. If it isn't what you expected, contact compradigitalyaa@gmail.com within the guarantee period.",
  ],
] as const
